export default {
  createClassType: 'create-class type',
  editClassType: 'edit-class type',
  viewClassType: 'view-class type',
  generalAttributes: 'general attributes',
  remark: 'remark',
}
